import Section from '@latitude/section';
import styled from 'styled-components';
import { MARGIN, BREAKPOINT, COLOR } from '@/utils/constants';
import { PADDING } from '@latitude/core/utils/constants';

export const StyledHeaderSection = styled(Section)`
  background-color: ${COLOR.BRAND_PRIMARY};
  padding: 0;

  .container {
    padding: 0;
  }

  @media (min-width: ${BREAKPOINT.MD}) {
    padding: ${PADDING.P24} 0;
  }
`;

export const StyledGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 0;
  align-items: center;

  @media (min-width: ${BREAKPOINT.MD}) {
    grid-template-columns: 1fr 1fr;
    gap: ${MARGIN.M24};
  }
`;

export const StyledTextContainer = styled.div`
  text-align: left;
  padding: ${PADDING.P8} ${PADDING.P16};
`;

export const StyledImage = styled.img`
  width: 100%;
  height: auto;
  order: -1;
  @media (min-width: ${BREAKPOINT.MD}) {
    order: 0;
  }
`;
